import { useMemo } from "react";

import TableCellEmpty from "ds/components/Table/Row/CellEmpty";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { IntentProject } from "types/generated";
import IntentProjectStateBadge from "shared/IntentProject/StateBadge";
import { IntentProjectSuggestions } from "shared/IntentProject/useSearchIntentProjectsSuggestions/constants";

import useCellFilterAction from "../useCellFilterAction";

const IntentProjectsTableStateCell = ({
  item: intentProject,
  ...cellProps
}: TableSimpleCellProps<IntentProject>) => {
  const filterAction = useCellFilterAction({
    filterName: IntentProjectSuggestions.STATE,
    filterValue: intentProject.state,
  });

  const actions = useMemo(() => [filterAction], [filterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      {intentProject.state === "NONE" ? (
        <TableCellEmpty />
      ) : (
        <IntentProjectStateBadge state={intentProject.state} />
      )}
    </TableSimpleCell>
  );
};

export default IntentProjectsTableStateCell;
